import React from "react"

import {
    Grid,
    Typography, Box
} from "@mui/material"
import {
    TabContext,
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    timelineItemClasses,
    TimelineSeparator,
} from "@mui/lab"

import {
    t,
    Trans,
} from "@lingui/macro"
import Icon from "@mdi/react"

import {
    ActionTimeline,
    ActionUtils,
    PaginatedResponse
} from "models"
import {
    SbTab,
    SbTabList,
} from "components/commons"

import { TimelineCard } from "../timeline/timeline-card"

interface ThirdColumnProps {
    handlePagination: (value: number) => void
    data: PaginatedResponse<ActionTimeline>
}
interface ThirdColumnState {
    page: number
}
export class ThirdColumn extends React.Component<ThirdColumnProps, ThirdColumnState> {
    constructor(props: ThirdColumnProps) {
        super(props)
        this.state = {
            page: 0,
        }
    }

    private handlePagination = (_: React.ChangeEvent<unknown>, value: number) => {
        this.props.handlePagination(value)
    }

    render() {
        const items: ActionTimeline[] = this.props.data.items ?? []

        return (
            <>
                <TabContext value={"1"}>
                    <Box sx={{ borderBottom: 0 }}>
                        <SbTabList variant="fullWidth">
                            <SbTab
                                disableRipple
                                disableTouchRipple
                                label={t({ id: "actions.timeline", message: "Timeline", })}
                                value="1" />
                        </SbTabList>
                    </Box>
                </TabContext>
                <Grid container>
                    {/*<Grid item xs={12} sx={{mt: 2}}>*/}
                    {/*    <TimelineFilters />*/}
                    {/*</Grid>*/}
                    {items.length !== 0 &&
                        <Grid item xs={12} sx={{ height: "50vh", mt: 2 }} overflow="auto">
                            <Timeline
                                sx={{
                                    paddingY: 0,
                                    margin: 0,
                                    [`& .${timelineItemClasses.root}:before`]: {
                                        flex: 0,
                                        padding: 0,
                                    },
                                }}>
                                {items.map((item: ActionTimeline, index) => (
                                    <TimelineItem key={item.id}>
                                        <TimelineSeparator>
                                            <TimelineDot>
                                                <Icon path={ActionUtils.renderIcon(item.action)} size={0.6} />
                                            </TimelineDot>
                                            {
                                                index !== (items.length - 1) &&
                                                <TimelineConnector />
                                            }
                                        </TimelineSeparator>
                                        <TimelineContent>
                                            <TimelineCard showState={true} timeline={item} />
                                        </TimelineContent>
                                    </TimelineItem>
                                ))}
                            </Timeline>
                        </Grid>
                    }
                    {items.length === 0 &&
                        <Grid container sx={{ display: "grid", placeItems: "center", height: "50vh" }}>
                            <Grid item xs={12} alignSelf="center">
                                <Typography>
                                    <Trans id="actions.no-actions">
                                        Nessuna azione trovata
                                    </Trans>
                                </Typography>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </>
        )
    }
}
